import { Fragment } from "react";

export default function NewLineText(props) {
  const string = props?.string ?? "";
  const lines = string
    .split("\n")
    .map((text) => ({ id: crypto.randomUUID(), text }));

  return lines.map(({ id, text }, idx) => (
    <Fragment key={id}>
      {idx > 0 && <br />}
      {text}
    </Fragment>
  ));
}
